module.exports = __webpack_public_path__ + "static/img/cadillac_3.b005318.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios-bluetooth/cadillac_3.png
// module id = l8JV
// module chunks = 216